module.exports = __webpack_public_path__ + "static/img/settings-dummy.532dfff4.png";